import styled, { css } from 'styled-components';
import { lighten } from 'polished';
import theme from '@styles/theme';

export const TableWrapper = styled.div<{
    $width?: string;
    $maxWidth?: number;
}>`
    width: ${({ $width }) => ($width ? $width : '100%')};
    border-top: ${theme.colors.blackColor} 1px solid;
    border-bottom: ${theme.colors.blackColor} 1px solid;
    // 가로 스크롤이 필요할 떄 사용. 최상위 테이블 DOM. TableHeader, TableBody의 부모로 쓸 것
    /* max-width: ${({ $maxWidth }) => ($maxWidth ? $maxWidth : 1117)}px;
    width: 100%;
    overflow-x: auto;
    &::-webkit-scrollbar {
        height: 8px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${theme.colors.progressBarColor};
        border-radius: 5px;
    }
    &::-webkit-scrollbar-track {
        background-color: ${theme.colors.whiteColor};
        border-radius: 5px;
    } */
`;

export const TableBody = styled.ul<{
    $maxWidth?: number;
    $height?: number;
    $minHeight?: number;
    $margin?: string;
}>`
    margin: ${({ $margin }) => ($margin ? $margin : 0)};
    width: 100%;
    max-width: ${({ $maxWidth }) => ($maxWidth ? $maxWidth : 955)}px;
    min-height: auto;

    &::-webkit-scrollbar {
        display: block;
        width: 8px;
    }
    &::-webkit-scrollbar-track,
    ::-webkit-scrollbar-button {
        display: none;
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${theme.colors.progressBarColor};
        border-radius: 4px;
    }

    ${({ $height }) =>
        $height &&
        css`
            height: ${$height}px;
            overflow-y: auto;
            overflow-x: hidden;
        `};

    ${({ $minHeight }) =>
        $minHeight &&
        css`
            min-height: ${$minHeight}px;
            overflow-y: auto;
            overflow-x: hidden;
        `};
`;

export const TableRow = styled.li<{
    $padding?: string;
    $disabled?: boolean;
    $default?: boolean;
    $scroll?: boolean;
    $isDragging?: boolean;
    $bgColor?: string;
    $fontColor?: string;
    $cursor?: string;
    $noBorder?: boolean;
    $bold?: boolean;
}>`
    position: relative;
    /* height: 50px; */
    padding: ${({ $padding }) => ($padding ? $padding : '15px 0')};
    min-height: 50px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${theme.colors.ultraLightGrayBorder};
    opacity: ${({ $isDragging }) => ($isDragging ? 0.4 : 1)};
    color: ${({ $fontColor }) =>
        $fontColor ? $fontColor : theme.colors.blackColor};
    background-color: ${({ $bgColor }) =>
        $bgColor ? $bgColor : theme.colors.whiteColor};
    cursor: ${({ $cursor }) => ($cursor ? $cursor : 'initial')};

    /* 클릭 이벤트 없는 일반 테이블 */
    ${({ $default }) =>
        !$default &&
        css`
            cursor: pointer;
            &:hover {
                background-color: ${theme.colors.lightGrayHoverColor};
            }
        `}

    /* 비활성화 */
    ${({ $disabled }) =>
        $disabled &&
        css`
            &:hover {
                background-color: ${theme.colors.whiteColor};
            }
            & * {
                color: ${theme.colors.lightGrayFontColor} !important;
            }
        `}
    /* 가로 스크롤 */
    ${({ $scroll }) =>
        $scroll &&
        css`
            width: fit-content;
        `}

        ${({ $noBorder }) =>
        $noBorder &&
        css`
            border-bottom: none;
        `}

        ${({ $bold }) =>
        $bold &&
        css`
            font-family: PretendardMedium, sans-serif;
        `}
`;

// export const TableTooltip = styled.div<{ $withButton?: boolean }>`
//     // css 참고 사이트
//     // https://projects.verou.me/bubbly
//     position: absolute;
//     top: -180%;
//     left: 50%;
//     transform: translateX(-50%);
//     display: none;
//     padding: 8px;
//     background-color: ${theme.colors.positiveBlue};
//     color: ${theme.colors.whiteColor};
//     font-size: 11px;
//     border-radius: 4px;
//     z-index: 10;

//     ${({ $withButton }) =>
//         $withButton &&
//         css`
//             top: -80%;
//         `}

//     &:after {
//         content: '';
//         position: absolute;
//         bottom: 0;
//         left: 50%;
//         width: 0;
//         height: 0;
//         border: 4px solid transparent;
//         border-top-color: ${theme.colors.positiveBlue};
//         border-bottom: 0;
//         margin-left: -4px;
//         margin-bottom: -4px;
//     }
//     // 첫번째 테이블 리스트 툴팁 하단 노출
//     ${TableRow}:first-child & {
//         top: 120%;
//         ${({ $withButton }) =>
//             $withButton &&
//             css`
//                 top: 100%;
//             `}
//         &:after {
//             content: '';
//             top: 0;
//             bottom: auto;
//             border: 4px solid transparent;
//             border-top-color: none;
//             border-bottom-color: ${theme.colors.positiveBlue};
//             border-bottom: auto;
//             border-top: 0;
//             margin-bottom: auto;
//             margin-top: -4px;
//         }
//     }
// `;

export const TableCell = styled.div<{
    $minWidth: number;
    $width?: number;
    $cursor?: boolean;
    $fontColor?: string;
    $alignRight?: boolean;
}>`
    position: relative;
    padding-left: 20px;
    min-width: ${({ $minWidth }) => $minWidth}px;
    width: ${({ $width, $minWidth }) =>
        $width ? `${$width}%` : `${$minWidth}px`};
    font-family: PretendardRegular, sans-serif;
    color: ${({ $fontColor }) => ($fontColor ? $fontColor : 'inherit')};
    font-size: 14px;
    font-family: inherit;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-height: 1.5;

    &:last-of-type {
        padding-right: 20px;
    }
    /* 셀에 별도의 클릭 이벤트가 있는 경우 */
    ${({ $cursor }) =>
        $cursor &&
        css`
            cursor: pointer;
            transition: 0.25s;
            &:hover {
                color: ${lighten(0.3, theme.colors.blackColor)};
            }
        `}

    ${({ $alignRight }) =>
        $alignRight &&
        css`
            &:last-of-type {
                text-align: right;
            }
        `}
`;

// export const TableText = styled.div`
//     text-overflow: ellipsis;
//     overflow: hidden;
//     white-space: nowrap;
//     line-height: 1.5;

//     &:hover ~ ${TableTooltip} {
//         display: inline-block;
//     }
// `;

export const EmptyTable = styled.li`
    padding: 20px;
    height: 200px;
    color: ${theme.colors.deepGrayFontColor};
    display: flex;
    align-items: center;
    justify-content: flex-start;
`;
